import _extends from '@babel/runtime/helpers/extends';
import React__default, { forwardRef } from 'react';
import { L as Label, I as Input } from './TileToggleArea.styles-BTrYCEAp.js';
import { u as useTaktId } from '../../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';

const TileToggleArea = /*#__PURE__*/forwardRef(({
  checked,
  children,
  disabled,
  focusProps,
  label,
  multiple,
  name,
  onChange,
  value,
  className,
  taktId,
  taktValue,
  ...restProps
}, ref) => {
  const {
    getDataTaktAttributes
  } = useTaktId({
    taktId,
    taktValue,
    fallbackId: 'tile-toggle-area'
  });
  return /*#__PURE__*/React__default.createElement(Label, _extends({}, getDataTaktAttributes(), {
    htmlFor: label,
    disabled: disabled,
    $active: checked,
    className: className
  }), /*#__PURE__*/React__default.createElement(Input, _extends({}, getDataTaktAttributes({
    taktIdSuffix: 'input'
  }), restProps, {
    focusProps: focusProps,
    ref: ref,
    id: label,
    type: multiple ? 'checkbox' : 'radio',
    checked: checked,
    "aria-checked": checked,
    disabled: disabled,
    name: name,
    value: value,
    onChange: onChange
  })), children);
});

export { TileToggleArea as T };
//# sourceMappingURL=TileToggleArea-Bo3zHRDz.js.map
